/* eslint-disable no-unused-vars */

export enum POINT_SETTING_SEASON_STATUS {
  WAIT, // 대기
  ING, // 진행 중
  END, // 종료
  ETC,
}

export enum POINT_LEDGER_STATUS {
  MINE, // 채굴
  REFERRAL, // 레퍼럴
  BONUS, // 보너스
  REFERRAL_MY, // 추천인을 입력하면 자기 자신에게도 지급
}
